import type {MentionThreadContext} from '@shm/shared/models/mention-ranking'
import type {UnpackedHypermediaId} from '@seed-hypermedia/client/hm-types'
import '@/blocknote/core/style.css'
import '@/editor.css'
import {
  BlockNoteView,
  FormattingToolbarPositioner,
  HyperlinkToolbarPositioner,
  LinkMenuPositioner,
  SlashMenuPositioner,
} from './blocknote'
import {HMFormattingToolbar} from './hm-formatting-toolbar'
import {HypermediaLinkPreview} from './hm-link-preview'
import {MentionMenuPositioner} from './mention-menu-positioner'
import type {HyperMediaEditor} from './types'

export function HyperMediaEditorView({
  editor,
  openUrl,
  perspectiveAccountUid,
  siteUid,
  documentId,
  mentionThread,
}: {
  editor: HyperMediaEditor
  openUrl: (url: string, newWindow?: boolean) => void
  siteUid?: string
  documentId?: UnpackedHypermediaId
  mentionThread?: MentionThreadContext
  perspectiveAccountUid?: string | null
}) {
  const editable = editor.isEditable
  return (
    <BlockNoteView editor={editor} className="hm-prose draft-editor">
      {editable && (
        <>
          <FormattingToolbarPositioner editor={editor} formattingToolbar={HMFormattingToolbar} />
          <SlashMenuPositioner editor={editor} />
          <LinkMenuPositioner editor={editor} />
        </>
      )}
      <HyperlinkToolbarPositioner
        // @ts-expect-error
        hyperlinkToolbar={HypermediaLinkPreview}
        editor={editor}
        // @ts-expect-error
        openUrl={openUrl}
      />
      <MentionMenuPositioner
        editor={editor}
        perspectiveAccountUid={perspectiveAccountUid}
        siteUid={siteUid}
        documentId={documentId}
        mentionThread={mentionThread}
      />
    </BlockNoteView>
  )
}
